module.exports = __webpack_public_path__ + "assets/img/transfer.e3855521.svg";